import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;

  .search-icon {
    position: absolute;
    left: 12px;
    color: rgb(117, 117, 117);
    font-size: 13px;
    pointer-events: none;
  }

  .cc-input {
    width: 100%;
  }

  .clear-search {
    position: absolute;
    right: 10px;
    line-height: 1;
    color: var(--white35);
    min-width: var(--spacer-20px);
  }
`;

type Props = Omit<React.ComponentPropsWithoutRef<'input'>, 'onChange' | 'type' | 'value'> & {
  search: string | undefined;
  onSearch: (value: string) => void;
};

export const SmartSearch = ({ className, style, search, onSearch, ...rest }: Props): React.ReactElement => (
  <Container className={cx('d-flex', 'align-items-center', className)} style={style}>
    <i className='search-icon far fa-search' />
    <input
      placeholder='Search'
      {...rest}
      type='search'
      className='cc-input cc-input--icon data-hj-allow'
      value={search ?? ''}
      onChange={(e): void => {
        onSearch(e.target.value);
      }}
    />
    {search && search.length > 0 && (
      <button
        type='button'
        className='clear-search x-pseudo'
        onClick={(): void => {
          onSearch('');
        }}
      >
        <span>&times;</span>
      </button>
    )}
  </Container>
);
